import { Card } from "@/components/ui/card";
import { Building } from "lucide-react";
import { useNavigate } from "react-router-dom";
import type { Tables } from "@/integrations/supabase/types";

interface SimilarPropertiesProps {
  properties: Tables<"real_estate_properties">[];
}

export const SimilarProperties = ({ properties }: SimilarPropertiesProps) => {
  const navigate = useNavigate();

  if (!properties?.length) return null;

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Similar Properties</h2>
      <div className="space-y-4">
        {properties.map((similar) => (
          <div
            key={similar.id}
            className="flex items-start space-x-4 p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
            onClick={() => navigate(`/real-estate/${similar.id}`)}
          >
            <div className="w-24 h-24 relative rounded-lg overflow-hidden flex-shrink-0">
              {similar.images?.[0] ? (
                <img
                  src={similar.images[0]}
                  alt={similar.title}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                  <Building className="h-8 w-8 text-gray-400" />
                </div>
              )}
            </div>
            <div>
              <h3 className="font-medium mb-1">{similar.title}</h3>
              <p className="text-sm text-muted-foreground mb-2">{similar.location}</p>
              <p className="text-sm font-medium">
                GHS {similar.price.toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};